import { forwardRef, HTMLAttributes, memo, ReactNode } from "react";
import classNames from "classnames";
import { VerificationInputBase, VerificationInputBaseProps } from "../VerificationInputBase";

import styles from "./style.module.scss";

export type VerificationInputSizeProps = "sm" | "md" | "lg";

export type VerificationCodeInputProps = VerificationInputBaseProps & {
  label?: ReactNode;
  hintText?: ReactNode;
  size?: VerificationInputSizeProps;
  containerProps?: HTMLAttributes<HTMLDivElement>
};

export const VerificationCodeInput = memo(
  forwardRef<HTMLDivElement, VerificationCodeInputProps>(
    (
      {
        label,
        hintText,
        size = "sm",
        containerProps,
        ...propsInput
      },
      ref
    ) => {

      return (
        <div
          {...containerProps}
          className={classNames(
            styles.root,
            styles[size as keyof typeof styles],
            styles[propsInput.inputState as keyof typeof styles],
          )}
          ref={ref}
          data-verification-size={size}
          data-verification-state={propsInput.inputState}
        >
          {label && <p className={styles.label}>{label}</p>}
          <VerificationInputBase
            {...propsInput}
            classNames={{
              ...propsInput.classNames,
              container: classNames(styles.container, propsInput.classNames?.container),
              character: classNames(styles.character, propsInput.classNames?.character)
            }}
          />
          {hintText && <p className={styles.hintText}>{hintText}</p>}
        </div>
      );
    }
  )
);